<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";

import MixinList from '@/Libs/Mixins/List.js';

export default {
    mixins: [MixinList],
    components: {
        Layout,
        PageHeader,
    },
    data() {
        return {
            routeName: 'email-template',
        }
    },
    methods: {
        async _search() {
            var search = this.search;

            if (!search.order_by) {
                search.order_by = 'module';
                search.sort_by = 'asc';
            }

            return await this.$api.EmailTemplate.all(search);
        },
        // ======
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="$t('email_template.title.list')" :pageTitle="$t('menu.sub_header.dashboard')" />
        <BRow>
            <BCol lg="12">
                <BCard no-body>
                    <BCardBody>
                        <div>
                            <div class="table-responsive table-card position-relative">
                                <loading :loading="$loading.get([routeName, 'list'].join('_'))" variant="dark"
                                    type="block">
                                    <table class="table align-middle table-hover table-nowrap mb-0">
                                        <thead class="table-light">
                                            <tr>
                                                <th style="width: 10px;">{{ $t('basic.label.line') }}</th>
                                                <th>{{ $t('email_template.label.category') }}</th>
                                                <th>{{ $t('email_template.label.subject') }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(tr, index) in list" :key="index" class="cursor-pointer"
                                                @click="($ac.hasAccess('config_email_template_show')) &&
                                                    ($router.push({ name: 'email-template-detail', params: { id: tr.category_id } }))">
                                                <td>{{ index + 1 }}</td>
                                                <td>{{ tr.category }}</td>
                                                <td>{{ tr.subject }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </loading>
                            </div>
                        </div>
                    </BCardBody>
                </BCard>
            </BCol>
        </BRow>
        <BRow class="mb-3">
            <BCol>
                <div>
                    <pagination v-bind:model="paginator" v-on:goto="goto"
                        :disabled="$loading.get([routeName, 'list'].join('_'))" />
                </div>
            </BCol>
        </BRow>
    </Layout>
</template>